import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-gift-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold font-heading text-background-50">福利吧</span>
            </Link>
            <p className="text-foreground-500 text-sm leading-relaxed">
              每日精选福利汇聚，好物好价不错过。
              关注福利吧，第一时间掌握最新福利动态，
              让每一分钱都花得值！
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-sm">
              福利分类
            </h4>
            <ul className="space-y-2.5">
              {categories.filter(c => c.slug !== 'all').map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-500 hover:text-accent-400 transition-colors text-sm cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-sm">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-foreground-500 hover:text-accent-400 transition-colors text-sm cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/flash-sale" className="text-foreground-500 hover:text-accent-400 transition-colors text-sm cursor-pointer">
                  限时秒杀
                </Link>
              </li>
              <li>
                <Link to="/category/free" className="text-foreground-500 hover:text-accent-400 transition-colors text-sm cursor-pointer">
                  免费领取
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-500 hover:text-accent-400 transition-colors text-sm cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-sm">
              联系方式
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-mail-line text-base"></i>
                <span>contact@fuliba.com</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-wechat-line text-base"></i>
                <span>微信公众号：福利吧</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-smartphone-line text-base"></i>
                <span>小程序：福利吧精选</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-600 text-xs">
            &copy; 2026 福利吧 FuliBar. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-600 hover:text-accent-400 transition-colors text-xs cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-foreground-600 hover:text-accent-400 transition-colors text-xs cursor-pointer" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-foreground-600 hover:text-accent-400 transition-colors text-xs cursor-pointer" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}